import React from 'react';
import Link from '@mui/material/Link';

const GuestPricing = () => {
  return (
    <section className="membership-section">
      <div className="membership-content">
        <div className="membership-left">
          <h2>Monthly Subscription</h2>
          <p>
            Give yourself or a loved one the gift of a subscription to <strong>That Which Is</strong> – MSIA’s streaming platform and your convenient gateway to MSIA’s extensive library of selections with John-Roger and John Morton.
          </p>
          <ul className="feature-list">
            <li>Unlimited access to MSIA’s library</li>
            <li>Mobile Access (iOS and Android)</li>
            <li>Create multiple personalized playlists</li>
            <li>Download and watch offline later</li>
            <li>1,000+ audio & video selections</li>
            <li>New content every week</li>
            <li>No commitment, cancel anytime</li>
          </ul>
          <div className="membership-cta">
            <p>Sign up today to start watching</p>
            <Link
              href="/app/students/login?previous_url=/media/videos/account/"
              className="cta-footer__button"
              color="inherit"
              underline="none"
            >
              Subscribe Now
            </Link>
          </div>
        </div>

        <div className="membership-right">
          <div className="price-box">
            <div className="price">$9.99</div>
            <div className="per">a month</div>
            <ul className="checklist">
              <li>✓</li>
              <li>✓</li>
              <li>✓</li>
              <li>✓</li>
              <li>✓</li>
              <li>✓</li>
              <li>✓</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuestPricing;